import { useTheme } from "app/shared";
import { FC } from "react";
import { PurchaseDetails } from "../sale-widget/sale-widget";

import styles from "./SmartWhitelistInfoComponent.module.scss";

interface ISmartWhitelistInfoComponent {
  handleCancelPurchase: () => void;
  isCancelSuccessful: boolean;
  currentPurchase: PurchaseDetails;
  currentStage: string;
}

const SmartWhitelistInfoComponent: FC<ISmartWhitelistInfoComponent> = ({
  handleCancelPurchase,
  isCancelSuccessful,
  currentPurchase,
  currentStage,
}) => {
  const { theme } = useTheme();

  return (
    <div
      className={`${styles.withdrawalWrapper} ${
        theme === "dark" ? styles.darkTheme : ""
      }`}
    >
      <div
        className={`${styles.withdrawText} ${
          theme === "dark" ? styles.darkTheme : ""
        }`}
      >
        <h3>SmartWhitelist Info</h3>
        <p>
          Pre-order your allocation right now to avoid waiting for the IDO to
          start. You can reserve your full allocation or a part of it (as you
          wish).
        </p>
        <p>
          If you change your mind - you always have a right to withdraw your
          deposit 24 hours before the IDO start (a small commission fee will be
          applicable at the withdrawal).
        </p>
        <p>
          Withdrawal commission 5%, while discounts applied to Karma holders: 0%
          for Alpha Tier; 1.25% for Beta Tier; 2.5% for Gamma Tier; 3.75% for
          Beginner Tier;
        </p>
      </div>
    </div>
  );
};
export default SmartWhitelistInfoComponent;
